<div class="trades-sub">
  @if (hasValidEditPermission()) {
    <div class="action-row justify-end trades-sub__head">
      <button type="button" class="btn btn-outline btn-sm" (click)="addEdit()">
        <i class="bi bi-plus-lg me-1"></i>
        Add trade requirement
      </button>
    </div>
  }

  <div class="trades-sub__grid">
    <app-primary-trade-license-requirements-grid
      [gridName]="'AdminPrimaryTradeLicenseRequirements'"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      [suppliedQueryData]="suppliedGridQuery"
      [(reloadGridData)]="reloadGrid"
      (actionEvent)="action($event)"
    ></app-primary-trade-license-requirements-grid>
  </div>
</div>
